export const actionTypes = {
  makeToast: 'toasts/makeToast'
};
